module.exports = __webpack_public_path__ + "img/002-woman.d74bc15a.svg";